import {graphql, Link} from 'gatsby'
import React from 'react'
import { ParallaxProvider } from 'react-scroll-parallax';


import Bio from '../components/bio.bs'
import Layout from '../components/layout.re'
import SEO from '../components/seo.bs'
import {rhythm} from '../utils/typography'

import '@deckdeckgo/highlight-code'
import { defineCustomElements as deckDeckGoHighlightElement } from '@deckdeckgo/highlight-code/dist/loader'
import '../components/main.css'


deckDeckGoHighlightElement()

const BlogIndex = ({data, location}) => {
  const siteTitle = data.site.siteMetadata.title
  const posts = data.allMarkdownRemark.edges

  return  (<ParallaxProvider className="parallaxBgr">
      <Layout location={location} title={siteTitle}>
        <SEO title='All posts' />
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug
          return (
            <article key={node.fields.slug}>
              <header>
                <h3
                  style={{
                    marginBottom: rhythm(1 / 4),
                  }}
                >
                  <Link style={{ boxShadow: `none`, fontFamily: `Inconsolata, monospace`, color: `#41876d` }} to={node.fields.slug}>
                    [{node.frontmatter.topictag}] {title}
                  </Link>
                </h3>
                <small>{node.frontmatter.date}</small>
              </header>
              <section>
                <p
                  dangerouslySetInnerHTML={{
                    __html: node.frontmatter.description || node.excerpt,
                  }}
                />
              </section>
            </article>
          )
        })}
      </Layout>
    </ParallaxProvider>)
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            topictag
            description
          }
        }
      }
    }
  }
`
